import { z } from 'zod';

import { VoiceTranscribeFormFields } from './FormFields';
import { TranscriptionType } from './constants';
import { voiceTranscribeDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const voiceTranscribeNodeConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'voiceTranscribe',
  defaultConfig: {
    storagePath: '',
    transcriptionType: 'CONVERSATION',
  },
  configFields: {
    schema: z.object({
      storagePath: z.string().min(1, { message: 'Cloud storage path is required' }),
      transcriptionType: z.enum(TranscriptionType, {
        message: 'Transcription type is required',
      }),
    }),
    FormFields: VoiceTranscribeFormFields,
  },
  documentationMarkdown: voiceTranscribeDocumentationMarkdown,
};
